import { Component } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { TranslateModule } from '@ngx-translate/core';
import { LogoComponent } from '../logo/logo.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  standalone: true,
  imports: [TranslateModule, LogoComponent, RouterLink],
})
export class FooterComponent extends BaseComponent {}
